<template>
<div @click="resultSelected" @mouseover="overImage" @mouseout="outImage" :class="['wrapper', {'over': over}]" >
    <transition name="gallery-fade">
      <div class="inner-wrapper" v-show="loaded">
        <div class="image-wrapper">
          <img class="image" :src="src" v-on:load="onLoaded">
          <transition name="gallery-fade">
            <div class="overImage" v-show="over">
              <div class="text">
                <span v-if="externalUrlColumn !== ''" class="see">{{ $ml.get('see') }}</span>
                <span v-else-if="idColumn !== ''" class="edit">{{ $ml.get('edit') }}</span>
              </div>
            </div>
          </transition>
          <div if="withLangLegend" class="lang-legend">
            <span>{{ getLangCode() }}</span>
          </div>
        </div>
        <span class="name">{{ name }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'searcher-gallery-image',
  props: [
    'idColumn',
    'externalUrlColumn',
    'src',
    'name',
    'withLangLegend'
  ],
  data () {
    return {
      loaded: false,
      over: false
    }
  },
  methods: {
    onLoaded () {
      this.loaded = true
    },
    resultSelected () {
      this.$emit('resultSelected')
    },
    overImage () {
      this.over = true
    },
    outImage () {
      this.over = false
    },
    getLangCode () {
      return this.$ml.get('isoCode').substr(0, 2).toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: center;
  cursor: pointer;
  margin-top: 25px;
  margin-bottom: 5px;
  width: 20%;
  display: inline-block;
  vertical-align: top;

  .inner-wrapper {
    padding: 10px 0 8px;
    background-color: #efefef;
    margin: 0 15px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    transition: background-color 0.2s ease-in-out;

    .image-wrapper {
      min-height: 500px;
      max-height: 500px;
      overflow-y: hidden;
      position: relative;
      margin: 0 10px;
      border-radius: 3px;
      transition: background-color 0.2s ease-in-out;

      img {
        width: calc(100% - 0px);
      }

      .overImage {
        position: absolute;
        background-color: rgba(0,0,0,0.2);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        .text {
          position: absolute;
          top: 50%;
          margin-top: -15px;
          text-align: center;
          left: 0;
          right: 0;
          transition: margin-top 0.2s ease-in-out;

          span {
            padding: 6px 22px 7px;
            color: #fff;
            text-transform: uppercase;
            background-color: #ff7643;
            font-size: 13px;
            border-radius: 3px;
            font-family: Capriola;
          }
        }
      }

      .lang-legend {
        color: #ff7643;
        text-transform: uppercase;
        font-size: 14px;
        border-radius: 3px;
        font-family: Capriola;
        background: linear-gradient(to bottom right, transparent 0%, transparent 50%, #d9d9d9 50%, #d9d9d9 100%);
        width: 45px;
        position: absolute;
        bottom: 0;
        right: 0;
        height: 45px;
        overflow: hidden;

        span {
          transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
          display: inline-block;
          position: absolute;
          bottom: 4px;
          right: 5px;
        }
      }
    }

    .name {
      display: block;
      text-align: left;
      font-size: 16px;
      color: #4599a4;
      padding: 6px 0 8px;
      margin: 8px 10px 0;
      font-family: Barlow;
      text-align: center;
      background-color: #fff;
      border-radius: 3px;
      transition: background-color 0.2s ease-in-out;
    }
  }

  &.over {
    .inner-wrapper {
      background-color: #e3e3e3;
      border: 1px solid #ff7643;
    }
  }
}
.horizontal {
  .wrapper {
    .inner-wrapper {
      .image-wrapper {
        min-height: 200px;
        max-height: 200px;

        img {
          width: 55%;
        }
      }
    }
  }
}
.gallery-fade-enter-active {
  transition: all 0.2s ease-in-out;
}
.gallery-fade-enter-to {
  opacity: 1;
}
.gallery-fade-enter {
  opacity: 0;

  .text {
    margin-top: -35px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/searcher/galleryImage.vue